import { DEFAULT_SYNC_INTERVAL } from 'constants/settings'

export default function getSyncTimeout() {
  // return JSON.parse(window.localStorage.getItem(key)) || defaultValue
  return window.localStorage.getItem('syncTimer') || DEFAULT_SYNC_INTERVAL
}
